import React, { useState } from 'react';
import Typography from '../../Components/DesignSystem/Typography/Typography';
import Button from '../../Components/DesignSystem/Button/Button';
import Badge from '../../Components/DesignSystem/Badge/Badge';
import Divider from '../../Components/DesignSystem/Divider/Divider';
import FieldTitle from '../../Components/DesignSystem/FieldTitle/FieldTitle';
import TextField from '../../Components/DesignSystem/TextField/TextField';
import Dropdown from '../../Components/DesignSystem/Dropdown/Dropdown';
import Toggle from '../../Components/DesignSystem/Toggle/Toggle';
import Checkbox from '../../Components/DesignSystem/Checkbox/Checkbox';
import Radio from '../../Components/DesignSystem/Radio/Radio';
import Tab from '../../Components/DesignSystem/Tab/Tab';
import Search from '../../Components/DesignSystem/Search/Search';
import Menu from '../../Components/DesignSystem/Menu/Menu';
import DropdownButton from '../../Components/DesignSystem/DropdownButton/DropdownButton';
import { SettingsIcon, NewGearIcon } from '../../assests/GmsIcons';

const DesignSystemShowcase = () => {
  const [textFieldValue, setTextFieldValue] = useState('');
  const [dropdownValue, setDropdownValue] = useState<string | number>('');
  const [toggleChecked, setToggleChecked] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [checkboxIndeterminate, setCheckboxIndeterminate] = useState(false);
  const [radioValue, setRadioValue] = useState<string | number>('option1');
  const [activeTabId, setActiveTabId] = useState<string | number>('tab1');
  const [searchValue, setSearchValue] = useState('');
  const [selectedMenuId, setSelectedMenuId] = useState<string | number>('menu1');
  const [selectedDropdownOption, setSelectedDropdownOption] = useState<string | number>('');

  const dropdownOptions = [
    { value: 'option1', label: 'Option 1' },
    { value: 'option2', label: 'Option 2' },
    { value: 'option3', label: 'Option 3' },
    { value: 'option4', label: 'Option 4' },
  ];

  const radioOptions = [
    { value: 'option1', label: 'Option 1' },
    { value: 'option2', label: 'Option 2' },
    { value: 'option3', label: 'Option 3' },
  ];

  const tabItems = [
    {
      id: 'tab1',
      label: 'Tab 1',
      content: 'This is the content for Tab 1',
    },
    {
      id: 'tab2',
      label: 'Tab 2',
      content: 'This is the content for Tab 2',
    },
    {
      id: 'tab3',
      label: 'Tab 3',
      content: 'This is the content for Tab 3',
    },
    {
      id: 'tab4',
      label: 'Disabled Tab',
      content: 'This tab is disabled',
      disabled: true,
    },
  ];

  const menuItems = [
    {
      id: 'menu1',
      label: 'New',
      icon: <SettingsIcon />,
    },
    {
      id: 'menu2',
      label: 'Edit',
      icon: <SettingsIcon />,
    },
    {
      id: 'menu3',
      label: 'Delete',
      icon: <SettingsIcon />,
    },
    {
      id: 'menu4',
      divider: true,
    },
    {
      id: 'menu5',
      label: 'Settings',
      icon: <SettingsIcon />,
    },
    {
      id: 'menu6',
      label: 'Disabled Option',
      icon: <SettingsIcon />,
      disabled: true,
    },
  ];

  const dropdownButtonOptions = [
    {
      id: 'option1',
      label: 'Save',
      icon: <SettingsIcon />,
    },
    {
      id: 'option2',
      label: 'Save As',
      icon: <SettingsIcon />,
    },
    {
      id: 'option3',
      label: 'Export',
      icon: <SettingsIcon />,
    },
    {
      id: 'option4',
      label: 'Disabled Option',
      icon: <SettingsIcon />,
      disabled: true,
    },
  ];

  return (
    <div className="tw-p-8 tw-bg-grey-100 tw-min-h-screen">
      <div className="tw-max-w-7xl tw-mx-auto">
        {/* Header */}
        <Typography variant="display" className="tw-mb-12 tw-text-grey-900">
          Design System Showcase
        </Typography>

        {/* Typography Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Typography
          </Typography>
          <div className="tw-space-y-6">
            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Display
              </Typography>
              <Typography variant="display">Display Text (24px, 400)</Typography>
            </div>

            <Divider />

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Heading 1
              </Typography>
              <Typography variant="heading-1">Heading 1 (18px, 700)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Heading 2
              </Typography>
              <Typography variant="heading-2">Heading 2 (18px, 500)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Title Header
              </Typography>
              <Typography variant="title-header">Title Header (14px, 600)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Title
              </Typography>
              <Typography variant="title">Title (14px, 500)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Body Primary
              </Typography>
              <Typography variant="body-primary">Body Primary (14px, 400)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Sub Title Header
              </Typography>
              <Typography variant="sub-title-header">Sub Title Header (12px, 700)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Sub Title Label
              </Typography>
              <Typography variant="sub-title-label">Sub Title Label (12px, 600)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Sub Body Supporting
              </Typography>
              <Typography variant="sub-body-supporting">Sub Body Supporting (12px, 500)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Caption Metadata
              </Typography>
              <Typography variant="caption-metadata">Caption Metadata (12px, 400)</Typography>
            </div>

            <div>
              <Typography variant="caption-metadata" className="tw-text-grey-600 tw-mb-2">
                Code Formula
              </Typography>
              <Typography variant="code-formula" as="code">
                const x = 42;
              </Typography>
            </div>
          </div>
        </section>

        {/* Button Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Buttons
          </Typography>

          <div className="tw-space-y-8">
            {/* Primary Buttons */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Primary
              </Typography>
              <div className="tw-flex tw-gap-4 tw-flex-wrap">
                <Button variant="primary">Default</Button>
                <Button variant="primary" icon={<NewGearIcon />} iconSize="small">
                  With Icon
                </Button>
                <Button variant="primary" icon={<NewGearIcon />} iconSize="small" showBadge badgeContent="8">
                  With Icon & Badge
                </Button>
                <Button variant="primary" disabled>
                  Disabled
                </Button>
                <Button variant="primary" disabled icon={<NewGearIcon />} iconSize="small">
                  Disabled with Icon
                </Button>
              </div>
            </div>

            <Divider />

            {/* Secondary Buttons */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Secondary
              </Typography>
              <div className="tw-flex tw-gap-4 tw-flex-wrap">
                <Button variant="secondary">Default</Button>
                <Button variant="secondary" icon={<NewGearIcon />} iconSize="small">
                  With Icon
                </Button>
                <Button variant="secondary" icon={<NewGearIcon />} iconSize="small" showBadge badgeContent="5">
                  With Icon & Badge
                </Button>
                <Button variant="secondary" disabled>
                  Disabled
                </Button>
                <Button variant="secondary" disabled icon={<NewGearIcon />} iconSize="small">
                  Disabled with Icon
                </Button>
              </div>
            </div>

            <Divider />

            {/* Tertiary Buttons */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Tertiary
              </Typography>
              <div className="tw-flex tw-gap-4 tw-flex-wrap">
                <Button variant="tertiary">Default</Button>
                <Button variant="tertiary" icon={<NewGearIcon />} iconSize="small">
                  With Icon
                </Button>
                <Button variant="tertiary" icon={<NewGearIcon />} iconSize="small" showBadge badgeContent="3">
                  With Icon & Badge
                </Button>
                <Button variant="tertiary" disabled>
                  Disabled
                </Button>
                <Button variant="tertiary" disabled icon={<NewGearIcon />} iconSize="small">
                  Disabled with Icon
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Badge Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Badges
          </Typography>

          <div className="tw-space-y-6">
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Warning (used in Primary)
              </Typography>
              <Badge variant="warning">8</Badge>
            </div>

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Primary (used in Primary Hover)
              </Typography>
              <Badge variant="primary">1</Badge>
            </div>

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Secondary (used in Secondary/Tertiary)
              </Typography>
              <Badge variant="secondary">5</Badge>
            </div>

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Disabled
              </Typography>
              <Badge variant="disabled">2</Badge>
            </div>
          </div>
        </section>

        {/* Divider Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Dividers
          </Typography>

          <div className="tw-space-y-8">
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Horizontal Solid
              </Typography>
              <Divider orientation="horizontal" variant="solid" />
            </div>

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Horizontal Dashed
              </Typography>
              <Divider orientation="horizontal" variant="dashed" />
            </div>

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Vertical Solid
              </Typography>
              <div className="tw-h-24 tw-flex tw-items-center">
                <Divider orientation="vertical" variant="solid" />
              </div>
            </div>
          </div>
        </section>

        {/* Form Inputs Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Form Inputs
          </Typography>

          <div className="tw-space-y-8">
            {/* Field Title */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Field Title
              </Typography>
              <div className="tw-space-y-2">
                <FieldTitle label="Default Label" />
                <FieldTitle label="Required Field" required />
              </div>
            </div>

            <Divider />

            {/* TextField */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Text Field
              </Typography>
              <div className="tw-space-y-6">
                <TextField
                  label="Default Text Field"
                  placeholder="Enter text"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Text Field with Helper"
                  placeholder="Enter email"
                  type="email"
                  helperText="Enter a valid email address"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Required Field"
                  placeholder="This is required"
                  required
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Disabled Field"
                  placeholder="Cannot edit"
                  disabled
                  value="Disabled value"
                />

                <TextField
                  label="Field with Copy Button"
                  placeholder="Click copy button"
                  value="copyable-value-123"
                  showCopyButton
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Error Field"
                  placeholder="Invalid input"
                  error
                  helperText="This field has an error"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="With Additional Info"
                  placeholder="Additional info below"
                  additionalInfo="This is additional information about this field"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="With Info Icon"
                  placeholder="Hover over the info icon"
                  infoMessage="This field requires a valid email address format"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Info Icon with Copy Button"
                  placeholder="Click copy or hover info"
                  infoMessage="Copy this identifier for reference"
                  value="field-identifier-789"
                  showCopyButton
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Required with Info Icon"
                  placeholder="This is required"
                  required
                  infoMessage="Please provide the required information"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Info Icon with Helper Text"
                  placeholder="Enter data"
                  infoMessage="Additional help available"
                  helperText="Use alphanumeric characters only"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />

                <TextField
                  label="Disabled with Info Icon"
                  placeholder="Cannot edit"
                  disabled
                  infoMessage="This field is currently disabled"
                  value="Disabled value"
                />

                <TextField
                  label="Error with Info Icon"
                  placeholder="Invalid input"
                  error
                  infoMessage="Click to learn more about this error"
                  helperText="This field has an error"
                  value={textFieldValue}
                  onChange={setTextFieldValue}
                />
              </div>
            </div>

            <Divider />

            {/* Dropdown */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Dropdown
              </Typography>
              <div className="tw-space-y-6">
                <Dropdown
                  label="Default Dropdown"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  placeholder="Select an option"
                />

                <Dropdown
                  label="Dropdown with Helper"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  helperText="Choose one from the list"
                />

                <Dropdown
                  label="Required Dropdown"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  required
                />

                <Dropdown
                  label="Disabled Dropdown"
                  options={dropdownOptions}
                  disabled
                  value="option1"
                />

                <Dropdown
                  label="Error Dropdown"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  error
                  helperText="Please select a valid option"
                />

                <Dropdown
                  label="With Additional Info"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  additionalInfo="This is additional information about this dropdown"
                />

                <Dropdown
                  label="With Info Icon"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  infoMessage="Select an option from the dropdown"
                  placeholder="Select an option"
                />

                <Dropdown
                  label="Required with Info Icon"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  required
                  infoMessage="This field is required"
                />

                <Dropdown
                  label="Info Icon with Helper"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  infoMessage="Additional help available"
                  helperText="Choose one from the list"
                />

                <Dropdown
                  label="Disabled with Info Icon"
                  options={dropdownOptions}
                  disabled
                  value="option1"
                  infoMessage="This dropdown is currently disabled"
                />

                <Dropdown
                  label="Error with Info Icon"
                  options={dropdownOptions}
                  value={dropdownValue}
                  onChange={setDropdownValue}
                  error
                  infoMessage="Click to learn more about this error"
                  helperText="Please select a valid option"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Toggle, Checkbox, Radio Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Toggle, Checkbox & Radio
          </Typography>

          <div className="tw-space-y-8">
            {/* Toggle Section */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Toggle
              </Typography>
              <div className="tw-space-y-4">
                <Toggle
                  label="Default Toggle (Unchecked)"
                  checked={toggleChecked}
                  onChange={setToggleChecked}
                />
                <Toggle
                  label="Default Toggle (Checked)"
                  checked={true}
                  onChange={() => {}}
                />
                <Toggle
                  label="Disabled Toggle (Unchecked)"
                  checked={false}
                  onChange={() => {}}
                  disabled={true}
                />
                <Toggle
                  label="Disabled Toggle (Checked)"
                  checked={true}
                  onChange={() => {}}
                  disabled={true}
                />
              </div>
            </div>

            <Divider />

            {/* Checkbox Section */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Checkbox
              </Typography>
              <div className="tw-space-y-4">
                <Checkbox
                  label="Default (Unchecked)"
                  checked={checkboxChecked}
                  onChange={setCheckboxChecked}
                />
                <Checkbox
                  label="Selected (Checked)"
                  checked={true}
                  onChange={() => {}}
                />
                <Checkbox
                  label="Mixed (Indeterminate)"
                  checked={false}
                  indeterminate={checkboxIndeterminate}
                  onChange={() => setCheckboxIndeterminate(!checkboxIndeterminate)}
                />
                <Checkbox
                  label="Disabled (Unchecked)"
                  checked={false}
                  onChange={() => {}}
                  disabled
                />
                <Checkbox
                  label="Disabled (Checked)"
                  checked={true}
                  onChange={() => {}}
                  disabled
                />
                <Checkbox
                  label="Disabled (Mixed)"
                  checked={false}
                  indeterminate={true}
                  onChange={() => {}}
                  disabled
                />
              </div>
            </div>

            <Divider />

            {/* Radio Section */}
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Radio Group
              </Typography>
              <div className="tw-space-y-4">
                <Radio
                  label="Default (Unselected)"
                  value="default"
                  checked={false}
                  onChange={setRadioValue}
                />
                <Radio
                  label="Selected (Checked)"
                  value="selected"
                  checked={true}
                  onChange={setRadioValue}
                />
                <Radio
                  label="Disabled (Unselected)"
                  value="disabled-unselected"
                  checked={false}
                  onChange={() => {}}
                  disabled
                />
                <Radio
                  label="Disabled (Checked)"
                  value="disabled-selected"
                  checked={true}
                  onChange={() => {}}
                  disabled
                />
              </div>
            </div>
          </div>
        </section>

        {/* Tab Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Tabs
          </Typography>

          <div className="tw-space-y-8">
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Default Tabs
              </Typography>
              <Tab
                tabs={tabItems}
                activeTabId={activeTabId}
                onChange={setActiveTabId}
              />
            </div>
          </div>
        </section>

        {/* Search Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Search
          </Typography>

          <div className="tw-space-y-8">
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Default Search
              </Typography>
              <Search
                placeholder="Search here..."
                value={searchValue}
                onChange={setSearchValue}
                clearable
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Search with Helper
              </Typography>
              <Search
                placeholder="Enter search term..."
                value={searchValue}
                onChange={setSearchValue}
                helperText="Type to search and press Enter"
                clearable
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Search Disabled
              </Typography>
              <Search
                placeholder="Disabled search..."
                value=""
                onChange={() => {}}
                disabled
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Search with Error
              </Typography>
              <Search
                placeholder="Enter valid search..."
                value=""
                onChange={() => {}}
                error
                helperText="Invalid search term"
              />
            </div>
          </div>
        </section>

        {/* Menu Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Menu
          </Typography>

          <div className="tw-space-y-8">
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Default Menu
              </Typography>
              <Menu
                items={menuItems}
                onItemClick={setSelectedMenuId}
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Compact Menu
              </Typography>
              <Menu
                items={menuItems}
                variant="compact"
                onItemClick={setSelectedMenuId}
              />
            </div>
          </div>
        </section>

        {/* DropdownButton Section */}
        <section className="tw-mb-12 tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-sm">
          <Typography variant="heading-1" className="tw-mb-6 tw-text-grey-900">
            Dropdown Button
          </Typography>

          <div className="tw-space-y-8">
            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Primary Dropdown Button
              </Typography>
              <DropdownButton
                label="Actions"
                options={dropdownButtonOptions}
                variant="primary"
                onSelect={setSelectedDropdownOption}
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Secondary Dropdown Button
              </Typography>
              <DropdownButton
                label="Options"
                options={dropdownButtonOptions}
                variant="secondary"
                onSelect={setSelectedDropdownOption}
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Tertiary Dropdown Button
              </Typography>
              <DropdownButton
                label="More"
                options={dropdownButtonOptions}
                variant="tertiary"
                onSelect={setSelectedDropdownOption}
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Disabled Dropdown Button
              </Typography>
              <DropdownButton
                label="Disabled"
                options={dropdownButtonOptions}
                disabled
                onSelect={setSelectedDropdownOption}
              />
            </div>

            <Divider />

            <div>
              <Typography variant="title-header" className="tw-text-grey-600 tw-mb-4">
                Right-Aligned Dropdown Button
              </Typography>
              <div className="tw-flex tw-justify-end">
                <DropdownButton
                  label="Align Right"
                  options={dropdownButtonOptions}
                  align="right"
                  onSelect={setSelectedDropdownOption}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DesignSystemShowcase;
